import { useBatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore/BatchSkiptraceStoreLive'

export const useBatchSkiptraceStats = () =>
  useBatchSkiptraceStore(store => store.stats.state)
